import type { ChartColorRef } from './types'

export const waterfallChartConfig = {
  defaultTitle: 'EQUITY & LIABILITY OVERVIEW',

  orientation: 'v' as const,
  textposition: 'outside' as const,
  hovermode: 'closest' as const,
  showLegend: false,

  colors: {
    title: 'textSecondary' as ChartColorRef,
    text: 'text' as ChartColorRef,
    axis: 'textSecondary' as ChartColorRef,
    grid: 'border' as ChartColorRef,
    connector: 'border' as ChartColorRef,
    increasing: 'success' as ChartColorRef,
    decreasing: 'error' as ChartColorRef,
    totals: 'primary' as ChartColorRef,
    errorText: 'error' as ChartColorRef,
  },

  /** Fallback palette when a category has no explicit `color`. */
  defaultCategoryColors: [
    'primary',
    'secondary',
    'tertiary',
    'quaternary',
    'info',
    'warning',
  ] as ChartColorRef[],

  totalCategoryColor: 'primary' as ChartColorRef,

  label: {
    wrapMaxLength: 10,
    tickFontSize: 11,
  },

  layout: {
    margins: { withTitle: { t: 35, r: 15, b: 30, l: 70 }, withoutTitle: { t: 5, r: 15, b: 30, l: 70 } },
    yAxisPaddingRatio: 0.15,
    yTickformat: '$,.0f',
    zerolineWidth: 2,
    showXGrid: false,
    showYGrid: true,
    tickangle: 0,
  },

  defaults: {
    height: '100%' as const,
    width: '100%' as const,
  },

  emptyMessage: 'No data available',

  plot: {
    hovertemplate: '<b>%{x}</b><br>Value: %{y:$,.0f}<br><extra></extra>',
    numberFormat: { minimumFractionDigits: 0, maximumFractionDigits: 0 },
  },
} as const
